import { UNCATEGORIZED_KEY } from './skillGrouping';
import { SkillLevel } from './types';

export type EmployeeSkillLeafRow = {
  rowType: 'skill';
  id: string;
  name: string;
  level: SkillLevel | undefined;
  isRateable: boolean;
  isTop: boolean;
  isTopLimitReached: boolean | undefined;
  rateLocked: boolean;
  removeLocked: boolean;
  monthsExperience: number | null;
  categoryId: string | null;
  categoryName: string | null;
};

export type EmployeeSkillCategoryRow = {
  rowType: 'category';
  id: string;
  name: string;
  skillCount: number;
  subRows: EmployeeSkillLeafRow[];
};

export type EmployeeSkillRow = EmployeeSkillLeafRow | EmployeeSkillCategoryRow;

export const buildCategoryRows = (
  leaves: EmployeeSkillLeafRow[],
  uncategorizedLabel: string,
): EmployeeSkillCategoryRow[] => {
  const groups = new Map<string, EmployeeSkillCategoryRow>();
  for (const leaf of leaves) {
    const key = leaf.categoryId ?? UNCATEGORIZED_KEY;
    const existing = groups.get(key);
    if (existing) {
      existing.subRows.push(leaf);
      existing.skillCount += 1;
    } else {
      groups.set(key, {
        rowType: 'category',
        id: key,
        name: leaf.categoryName ?? uncategorizedLabel,
        skillCount: 1,
        subRows: [leaf],
      });
    }
  }
  for (const group of groups.values()) {
    group.subRows.sort((a, b) => a.name.localeCompare(b.name));
  }
  return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name));
};
